<script lang="ts" setup>
import { useCityStore } from '@/store/city/city'
import { useObserversStore } from '@/store/observers/observers'

const { cityInfo, phones } = useCityStore()
const { categoryListState } = storeToRefs(useObserversStore())
</script>

<template>
  <header class="header">
    <div
      class="header__container"
      :class="{ 'header__container--hidden': categoryListState }"
    >
      <header-info
        :is-active="cityInfo.is_active"
        :city-name="cityInfo.visible_name"
        :phones="phones"
      />

      <header-widgets :is-active="cityInfo.is_active" />
    </div>

    <header-bottom-menu />
  </header>
</template>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  max-height: 144px;
  background: var(--ui-color-white);

  &__container {
    display: flex;
    justify-content: space-between;
    padding: 28px 24px;

    @include media('>=desktop') {
      max-width: 1200px;
      padding: 28px 0;
      margin: 0 auto;
      transition: padding 0.2s ease-in;

      &--hidden {
        padding: 14px 0;
      }
    }
  }
}
</style>
